import api from "../index";

export const SavePaymentGatewayApi = (data) => api.post("save-payment-gateway", data);
